import { RefObject, useState } from 'react'

type HoverOptions = {
  delayTime?: number
} & ({
  addMovingHover: true
  hoverRef: RefObject<HTMLElement>
} | {
  addMovingHover?: false
})

const useHover = (
  containerRef: RefObject<HTMLElement>,
  options?: HoverOptions
) => {
  const [isHover, showHover] = useState(false)

  const onHover = (_: React.MouseEvent) => {
    const container = containerRef.current
    if (!container) return

    const onMove = (e: MouseEvent) => {
      if (options?.addMovingHover && options.hoverRef.current) {
        options.hoverRef.current.style.top = `${e.clientY - 40}px`
        options.hoverRef.current.style.left = `${e.clientX}px`
      }
    }

    const onLeave = () => {
      showHover(false)
      clearTimeout(lazyLoading)
      container.removeEventListener('mouseleave', onLeave)
      if (options?.addMovingHover) container.removeEventListener('mousemove', onMove)
    }

    const generateHover = () => {
      showHover(true)
      if (options?.addMovingHover) container.addEventListener('mousemove', onMove)
    }

    const lazyLoading = setTimeout(generateHover, options?.delayTime || 100)
    container.addEventListener('mouseleave', onLeave)
  }

  return {
    isHover,
    onHover
  }
}

export default useHover